import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // 🔥 Mobile me auto collapse
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);

  return (
    <Box sx={{ display: "flex" }}>
      {/* ✅ Sidebar */}
      <Sidebar collapsed={collapsed} />

      {/* ✅ Main Content */}
      <Box sx={{ flexGrow: 1 }}>
        {/* Header */}
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />

        {/* Page Content */}
        <Box
          sx={{
            p: 2,
            background: "#f5f5f5",
            height: "calc(100vh - 60px)",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
